import React, { Component } from 'react';
// import {BrowserRouter as Router} from 'react-router-dom'
import './body.css'
import { Parallax, Footer } from 'react-materialize';
// import PageFooter from '../Footer/footer';
import background from '../../assets/adventure.jpg';
import Portfolio from '../Portfolio/portfolio';
import AboutMe from '../aboutMe/aboutMe'
import Landing from '../Landing/Landing';
import github from '../../assets/github-original.svg';
import mail from '../../assets/letter.svg';
import linkedin from '../../assets/linkedin-original.svg';
import NavBar from '../NavBar/NavBar';
import RocketLoader from '../RocketLoader/RocketLoader';
// import anime from 'animejs'
import AOS from 'aos';

let bodyMargins = {
    overflow: 'hidden',
    width: '100%'
}


class Body extends Component {

    state = {
        loading: true
    }

    render() {
        return (
            <div style={bodyMargins}>
                {/* <RocketLoader/> */}
                <Landing />
                <AboutMe/>
                <Portfolio />
                {/* <PageFooter /> */}
                <Footer data-aos='fade-up' copyrights="2019 Copyright TheNicholasCowan.com"
                    links={
                        <ul>
                            <li><a className="grey-text text-lighten-3" href="https://github/Nismo-Gtr" id="footerLinks"><img src={github} alt="Git Hub Logo" /></a></li>
                            <li><a className="grey-text text-lighten-3" href="https://linkedin.com/in/thenicholascowan" id="footerLinks"><img src={linkedin} alt="Linked in Logo" /></a></li>
                            <li><a className="grey-text text-lighten-3" href="mailto:Nick@TheNicholasCowan.com" id="footerLinks"><img src={mail} alt="Email Logo" /></a></li>
                        </ul>
                    }
                    className='transparent'
                >
                    <h5 className="black-text">Nicholas Cowan</h5>
                    <p className="black-text text-lighten-4">Let me build something wonderful for you.</p>
                </Footer>
            </div>
        )
    }
}


export default Body;


// WEBPACK FOOTER //
// ./src/components/body/body.js